module.exports = __webpack_public_path__ + "static/media/admin-icon.f493f911.svg";